import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  useRef,
  useCallback,
} from "react";
import api from "../utils/api";
import { apiUrls } from "../utils/urls";
import useAuth from "../hooks/auth/useAuth";

const ProfileContext = createContext();

export const useProfile = () => useContext(ProfileContext);

export const ProfileProvider = ({ children }) => {
  const { token, refreshToken } = useAuth();
  const [profile, setProfile] = useState({
    uuid: null,
    profile_pic_url: null,
    allow_texts: false,
    allow_emails: false,
    user: {
      first_name: null,
      last_name: null,
      username: null,
    },
  });
  const fetchingProfileInProgress = useRef(false);

  const fetchUserProfile = useCallback(async () => {
    fetchingProfileInProgress.current = true;
    try {
      const { data } = await api.get(apiUrls.users.profile());
      if (!data?.success) {
        refreshToken().then(() => window.location.reload());
        return;
      }
      setProfile(data);
      return data;
    } catch (error) {
      console.log("Unable to retrieve profile information.");
    }
    fetchingProfileInProgress.current = false;
  }, [refreshToken]);

  useEffect(() => {
    if (
      token &&
      !profile?.user?.username &&
      !fetchingProfileInProgress.current
    ) {
      fetchUserProfile();
    }
  }, [token, profile?.user?.username, fetchUserProfile]);

  return (
    <ProfileContext.Provider
      value={{
        profile,
        setProfile,
        refetchUser: fetchUserProfile,
        isLoaded: !!profile?.user?.username,
      }}
    >
      {children}
    </ProfileContext.Provider>
  );
};
